/**
 * USPTO Kind Codes
 * Source: https://www.uspto.gov/patents/search/authority-files/uspto-kind-codes
 */
export const kindCodes: Record<string, string> = {
  // Utility Patents
  A: "Utility Patent (pre-2001)",
  A1: "Utility Patent Application",
  A2: "Utility Patent Application (2nd+)",
  A9: "Corrected Utility Patent Application",
  B1: "Utility Patent (no pre-grant pub)",
  B2: "Utility Patent (with pre-grant pub)",

  // Reexamination Certificates
  B1: "Utility Patent Grant",
  B2: "Utility Patent Grant",
  C1: "Reexamination Certificate",
  C2: "Reexamination Certificate",
  C3: "Reexamination Certificate",

  // Reissue
  E: "Reissue Patent",
  E1: "Reissue Patent",

  // Statutory Invention Registration
  H: "Statutory Invention Registration",
  H1: "Statutory Invention Registration",

  // Historical
  I1: "X Patent (1790-1836)",
  I2: "X Reissue Patent (1790-1836)",
  I3: "Additional Improvements (1838-1861)",
  I4: "Defensive Publication",
  I5: "Trial Voluntary Protest Program",

  // Plant Patents
  P: "Plant Patent (pre-2001)",
  P1: "Plant Patent Application",
  P2: "Plant Patent (no pre-grant pub)",
  P3: "Plant Patent (with pre-grant pub)",
  P4: "Plant Patent Application (2nd+)",
  P9: "Corrected Plant Patent Application",

  // Design Patents
  S: "Design Patent",
  S1: "Design Patent",
};

/**
 * Publication Types for Design Patents
 */
export const publicationTypes: Record<string, string> = {
  G: "Granted Patent",
  D: "Design Patent",
  A: "Application",
};

/**
 * Locarno Classification - Class Headings
 * Source: WIPO Locarno Classification
 */
export const locarnoClasses: Record<string, string> = {
  "01": "Foodstuffs",
  "02": "Clothing & Haberdashery",
  "03": "Travel Goods & Cases",
  "04": "Brushware",
  "05": "Textiles & Sheet Material",
  "06": "Furnishing",
  "07": "Household Goods",
  "08": "Tools & Hardware",
  "09": "Packaging & Containers",
  "10": "Clocks, Watches & Instruments",
  "11": "Articles of Adornment",
  "12": "Transport & Hoisting",
  "13": "Electrical Equipment",
  "14": "Recording & Telecom Equipment",
  "15": "Machines",
  "16": "Photography & Cinematography",
  "17": "Musical Instruments",
  "18": "Printing & Office Machinery",
  "19": "Stationery & Office Equipment",
  "20": "Sales & Advertising Equipment",
  "21": "Games, Toys & Sports Goods",
  "22": "Arms & Hunting Equipment",
  "23": "Fluid Distribution & HVAC",
  "24": "Medical & Laboratory Equipment",
  "25": "Building Units & Construction",
  "26": "Lighting",
  "27": "Tobacco & Smoking Articles",
  "28": "Pharmaceutical & Cosmetic Products",
  "29": "Fire Prevention & Safety",
  "30": "Animal Husbandry",
  "31": "Food Preparation Machines",
  "32": "Graphic Symbols & Logos",
  "99": "Miscellaneous",
};

/**
 * Get human-readable kind code description
 */
export function getKindCodeDescription(kind?: string): string | null {
  if (!kind) return null;
  return kindCodes[kind] || kindCodes[kind.toUpperCase()] || null;
}

/**
 * Get human-readable publication type description
 */
export function getPublicationTypeDescription(type?: string): string | null {
  if (!type) return null;
  return publicationTypes[type] || publicationTypes[type.toUpperCase()] || null;
}

/**
 * Get human-readable Locarno class description
 */
export function getLocarnoClassDescription(classCode?: string): string | null {
  if (!classCode) return null;
  // Pad single digit to two digits
  const paddedCode = classCode.padStart(2, "0");
  return locarnoClasses[paddedCode] || null;
}

/**
 * Format Locarno code with description
 */
export function formatLocarnoCode(
  classCode?: string,
  subclassCode?: string
): { code: string; description: string | null } | null {
  if (!classCode) return null;

  const paddedClass = classCode.padStart(2, "0");
  const code = subclassCode ? `${paddedClass}-${subclassCode}` : paddedClass;
  const description = getLocarnoClassDescription(classCode);

  return { code, description };
}
